/* Chat conseiller cafe de Singular Coffee.
   Un seul fichier, sans dependance. Deux modes, pilotes par la section :
   - bubble : bulle flottante sur tout le site, panneau fixe (plein ecran sur mobile) ;
   - inline : panneau dans la page du quiz, qui passe en plein ecran sur mobile
     des que le visiteur touche le champ de saisie.
   La conversation est partagee entre les deux modes (localStorage) ; les deux peuvent
   cohabiter sur une meme page, sauf si la section integree demande de masquer la bulle.
   Abonnement et cadeau : hors du chat depuis le 27/09/2026 (renvoi vers les pages du site) ;
   le module retire le 28/09 est archive dans Quiz IA/archive/. */
(function () {
  'use strict';

  var STORAGE_KEY = 'sc-coffee-chat-v1';
  var DISMISS_KEY = 'sc-coffee-chat-dismissed'; // sessionStorage : la bulle revient a la visite suivante
  var LEAD_DISMISS_KEY = 'sc-coffee-chat-lead-dismissed'; // croix sur la pastille -10 % : plus jamais dans la session
  var MAX_TURNS = 60;
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Etat partage (conversation) ─────────────────────────────── */

  function newId() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !Array.isArray(s.api) || !Array.isArray(s.ui)) return null;
      if (!s.id) s.id = newId(); // conversations d'avant le journal
      return s;
    } catch (e) {
      return null;
    }
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  // `id` identifie la conversation dans le journal (table chat_conversations) ; il ne
  // contient rien sur la personne et change a chaque « Recommencer ».
  function emptyState() {
    return { id: newId(), api: [], ui: [], chips: [], started: Date.now() };
  }

  /* ── Rendu du texte (markdown minimal, sans HTML brut) ───────── */

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderMarkdown(text) {
    var blocks = text.replace(/\r/g, '').split(/\n{2,}/);
    var html = '';
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i].trim();
      if (!b) continue;
      var lines = b.split('\n');
      var isList = lines.every(function (l) { return /^\s*[-•]\s+/.test(l); });
      if (isList) {
        html += '<ul>' + lines.map(function (l) {
          return '<li>' + inline(l.replace(/^\s*[-•]\s+/, '')) + '</li>';
        }).join('') + '</ul>';
      } else {
        html += '<p>' + lines.map(inline).join('<br>') + '</p>';
      }
    }
    return html || '<p></p>';
  }

  function inline(s) {
    return escapeHtml(s)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g, '<a href="$2">$1</a>');
  }

  /* ── Balisage de fin de message (@@cafes, @@choix, @@profil, @@email) ──
     Le modele termine son texte par des lignes "@@cafes handle | pourquoi",
     "@@choix a | b | c", "@@profil {json}" (profil de gout structure, ecrit avec
     la recommandation : journal et Klaviyo) et "@@email" (proposition de garder la
     selection par email : le widget affichera un bouton et un formulaire, l'adresse
     n'est jamais tapee dans la conversation). On les retire du texte affiche. Pendant le streaming, on cache aussi un debut de balise. */

  function splitMarkers(raw, streaming) {
    var idx = raw.search(/(^|\n)\s*@@/);
    var visible = idx === -1 ? raw : raw.slice(0, idx);
    if (streaming && idx === -1) {
      // Un "@" ou "\n@" isole en fin de flux est peut-etre une balise qui commence.
      visible = visible.replace(/\n?\s*@?$/, '');
    }
    var cards = [];
    var chips = [];
    var profile = null;
    var email = false;
    if (idx !== -1) {
      raw.slice(idx).split('\n').forEach(function (line) {
        var m = line.match(/^\s*@@(cafes|choix|profil|email)\b\s*(.*)$/i);
        if (!m) return;
        var kind = m[1].toLowerCase();
        if (kind === 'cafes') {
          var parts = m[2].split('|');
          var handle = parts[0].trim();
          if (handle && cards.length < 3) cards.push({ handle: handle, pourquoi: (parts[1] || '').trim().slice(0, 160) });
        } else if (kind === 'choix') {
          m[2].split('|').forEach(function (o) {
            o = o.trim();
            if (o && chips.length < 4) chips.push(o.slice(0, 40));
          });
        } else if (kind === 'profil') {
          try {
            var pr = JSON.parse(m[2]);
            if (pr && typeof pr === 'object' && !Array.isArray(pr)) profile = pr;
          } catch (e) { /* profil illisible : ignore, les cartes suffisent */ }
        } else if (kind === 'email') {
          // La balise porte l'introduction de l'email de selection, ecrite par le modele.
          email = { intro: m[2].trim().slice(0, 400) };
        }
      });
    }
    return { visible: visible.replace(/\s+$/, ''), cards: cards, chips: chips, profile: profile, email: email };
  }

  /* ── Machine a ecrire : lisse l'arrivee du texte en streaming ── */

  function Typewriter(onFrame) {
    this.full = '';
    this.shown = 0;
    this.done = false;
    this.raf = 0;
    this.onFrame = onFrame;
  }
  Typewriter.prototype.push = function (delta) {
    this.full += delta;
    this.tick();
  };
  Typewriter.prototype.finish = function () {
    this.done = true;
    this.tick();
  };
  Typewriter.prototype.flush = function () {
    this.shown = this.full.length;
    this.done = true;
    cancelFrame(this.raf);
    this.raf = 0;
    this.onFrame(this.full, true);
  };
  // Une image par requestAnimationFrame quand l'onglet est visible ; sinon (onglet masque,
  // le navigateur gele les animations) une minuterie, pour que le texte finisse de s'ecrire
  // et que les boutons arrivent meme si le visiteur a change d'onglet entre-temps.
  function nextFrame(fn) {
    return document.hidden ? { timer: setTimeout(fn, 16) } : { frame: requestAnimationFrame(fn) };
  }
  function cancelFrame(h) {
    if (!h) return;
    if (h.timer) clearTimeout(h.timer);
    else cancelAnimationFrame(h.frame);
  }
  Typewriter.prototype.tick = function () {
    if (this.raf) return;
    var self = this;
    this.raf = nextFrame(function step() {
      self.raf = 0;
      var backlog = self.full.length - self.shown;
      if (backlog <= 0) {
        if (self.done) self.onFrame(self.full, true);
        return;
      }
      // Rythme de base : 2 caracteres par image (~120 c/s), accelere quand
      // le retard grandit ou que le flux est termine, pour ne jamais trainer.
      var speed = REDUCED_MOTION ? backlog : Math.max(2, Math.ceil(backlog / (self.done ? 6 : 24)));
      self.shown = Math.min(self.full.length, self.shown + speed);
      self.onFrame(self.full.slice(0, self.shown), self.done && self.shown >= self.full.length);
      if (self.shown < self.full.length || !self.done) {
        self.raf = nextFrame(step);
      }
    });
  };

  /* ── Panier (memes proprietes Globo que les cartes du site) ──── */

  var GRINDS = ['En grains', 'Moulu fin (espresso)', 'Moulu grossier (filtre)'];

  /* Mouture d'une carte d'apres le profil ecrit par le modele (@@profil) :
     - "grains" : En grains, sans choix ;
     - "moulu" avec une seule methode : moulu fin (espresso, italienne) ou grossier (filtre), sans choix ;
     - "moulu" avec espresso ET filtre, ou mouture inconnue : la carte propose le choix
       (regle Manesse du 27/09), pre-regle d'apres la methode du cafe. */
  function grindFor(profile, product) {
    var methods = (profile && Array.isArray(profile.methodes) ? profile.methodes : []).map(function (m) { return String(m).toLowerCase(); });
    var hasEsp = methods.indexOf('espresso') !== -1 || methods.indexOf('italienne') !== -1;
    var hasFil = methods.indexOf('filtre') !== -1;
    var brew = (product.brew || []).map(function (b) { return String(b).toLowerCase(); });
    var byProduct = brew.length === 1 && brew[0] === 'filtre' ? GRINDS[2] : GRINDS[1];
    var mouture = profile && profile.mouture ? String(profile.mouture).toLowerCase() : '';
    if (mouture === 'grains') return { value: GRINDS[0], choice: false };
    if (mouture === 'moulu') {
      if (hasEsp && hasFil) return { value: byProduct, choice: true };
      if (hasFil) return { value: GRINDS[2], choice: false };
      if (hasEsp) return { value: GRINDS[1], choice: false };
      return { value: byProduct, choice: true };
    }
    return { value: GRINDS[0], choice: true };
  }

  function addToCart(variantId, grind) {
    if (GRINDS.indexOf(grind) === -1) grind = GRINDS[0];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _has_gpo: '990329', Mouture: grind } }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        updateCartBubble(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
    });
  }

  function updateCartBubble(cart) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (!bubble && cart.item_count > 0) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      icon.appendChild(bubble);
    }
    if (!bubble) return;
    bubble.querySelector('span[aria-hidden="true"]').textContent = cart.item_count;
    bubble.querySelector('.visually-hidden').textContent = cart.item_count + ' articles';
    bubble.classList.toggle('hidden', cart.item_count === 0);
  }


  /* ── Catalogue a la demande ───────────────────────────────────── */

  var CATALOG_CACHE_KEY = 'sc-coffee-chat-catalog';
  var CATALOG_TTL = 15 * 60 * 1000;
  var catalogPromises = {}; // une requete par URL, partagee par les instances de la page

  function fetchCatalog(url) {
    if (catalogPromises[url]) return catalogPromises[url];
    try {
      var cached = JSON.parse(sessionStorage.getItem(CATALOG_CACHE_KEY) || 'null');
      if (cached && cached.url === url && Date.now() - cached.at < CATALOG_TTL && cached.data) {
        return (catalogPromises[url] = Promise.resolve(cached.data));
      }
    } catch (e) {}
    catalogPromises[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('catalogue ' + r.status);
        return r.text();
      })
      .then(function (html) {
        // La section arrive enveloppee dans un <div> : on ne garde que le JSON.
        var start = html.indexOf('{');
        var end = html.lastIndexOf('}');
        if (start < 0 || end < 0) throw new Error('catalogue vide');
        var data = JSON.parse(html.slice(start, end + 1));
        if (!data || !Array.isArray(data.cafes)) throw new Error('catalogue invalide');
        try { sessionStorage.setItem(CATALOG_CACHE_KEY, JSON.stringify({ url: url, at: Date.now(), data: data })); } catch (e) {}
        return data;
      })
      .catch(function (err) {
        delete catalogPromises[url]; // on pourra reessayer
        throw err;
      });
    return catalogPromises[url];
  }

  // Ce que les cartes ont besoin de garder dans l'historique (reprise sans catalogue).
  function cardSnapshot(p) {
    return {
      handle: p.handle, title: p.title, vendor: p.vendor, url: p.url, image: p.image,
      variant_id: p.variant_id, price: p.price, compare_at_price: p.compare_at_price || '', brew: p.brew || [], notes: p.notes || [], origin: p.origin || ''
    };
  }

  /* ── Widget ──────────────────────────────────────────────────── */

  var instances = [];

  function CoffeeChat(root) {
    this.root = root;
    this.mode = root.dataset.mode === 'inline' ? 'inline' : 'bubble';
    this.endpoint = root.dataset.endpoint || '';
    this.welcome = root.dataset.welcome || '';
    this.initialChips = (root.dataset.suggestions || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    this.debug = root.dataset.debug === 'true';

    // Catalogue {cafes, torrefacteurs} : PAS dans la page. Charge au premier geste du visiteur
    // depuis la section technique (data-catalog-url), partage entre les instances de la page,
    // garde 15 min dans sessionStorage. Envoye tel quel au serveur ; les cartes se servent
    // de la liste des cafes (et d'un instantane garde dans l'historique pour la reprise).
    this.catalogUrl = root.dataset.catalogUrl || '';
    this.catalogData = { cafes: [], torrefacteurs: [] };
    this.catalog = [];
    this.byHandle = {};
    this.catalogReady = false;

    this.el = {
      launcher: root.querySelector('[data-cc-launcher]'),
      panel: root.querySelector('[data-cc-panel]'),
      log: root.querySelector('[data-cc-log]'),
      chips: root.querySelector('[data-cc-chips]'),
      input: root.querySelector('[data-cc-input]'),
      send: root.querySelector('[data-cc-send]'),
      close: root.querySelector('[data-cc-close]'),
      maximize: root.querySelector('[data-cc-maximize]'),
      dismiss: root.querySelector('[data-cc-dismiss]'),
      reset: root.querySelector('[data-cc-reset]'),
      leadFloat: root.querySelector('[data-cc-lead-float]')
    };

    this.leadEndpoint = String(root.dataset.endpoint || '').replace(/\/chat\/?$/, '/lead');
    this.eventEndpoint = String(root.dataset.endpoint || '').replace(/\/chat\/?$/, '/event');
    this.state = loadState() || emptyState();
    this.busy = false;
    this.controller = null;
    this.open = false;
    this.maximized = false;

    this.bind();
    this.renderAll();
    if (this.mode === 'inline') this.bootConversation();
    instances.push(this);
  }

  // Journal : ajout au panier. Balise « fire and forget » (sendBeacon,
  // texte brut pour eviter la pre-verification CORS), qui survit a une navigation vers le checkout.
  CoffeeChat.prototype.beacon = function (type, data) {
    if (!this.eventEndpoint || !this.state.id) return;
    var payload = JSON.stringify(Object.assign({ conversation_id: this.state.id, type: type }, data || {}));
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(this.eventEndpoint, payload)) return;
    } catch (e) {}
    try {
      fetch(this.eventEndpoint, { method: 'POST', body: payload, keepalive: true }).catch(function () {});
    } catch (e) {}
  };

  CoffeeChat.prototype.ensureCatalog = function () {
    var self = this;
    if (this.catalogReady) return Promise.resolve(this.catalogData);
    if (!this.catalogUrl) return Promise.reject(new Error('pas de catalogue'));
    return fetchCatalog(this.catalogUrl).then(function (data) {
      self.catalogData = data;
      self.catalog = data.cafes;
      self.byHandle = {};
      self.catalog.forEach(function (p) { self.byHandle[p.handle] = p; });
      self.catalogReady = true;
      return data;
    });
  };

  CoffeeChat.prototype.bind = function () {
    var self = this;
    if (this.el.launcher) this.el.launcher.addEventListener('click', function () { self.setOpen(true); });
    // Premier geste dans le panneau : on va chercher le catalogue (une fois, sans bloquer).
    var warm = function () { self.ensureCatalog().catch(function () {}); };
    this.el.panel.addEventListener('pointerdown', warm, { once: true });
    this.el.panel.addEventListener('focusin', warm, { once: true });
    if (this.el.close) this.el.close.addEventListener('click', function () {
      // Integre : la croix ne sert qu'a quitter le plein ecran (desktop ou mobile). Bulle : elle ferme tout.
      if (self.mode === 'inline' && self.maximized) self.setMaximized(false);
      else if (self.mode === 'inline') self.setExpanded(false);
      else self.setOpen(false);
    });
    if (this.el.maximize) this.el.maximize.addEventListener('click', function () {
      // Mobile, integre : le bouton fait entrer et sortir du plein ecran mobile.
      if (MOBILE.matches) {
        if (self.mode === 'inline') self.setExpanded(!self.root.classList.contains('is-expanded'));
        return;
      }
      self.setMaximized(!self.maximized);
    });

    // Mobile, mode integre : un tap n'importe ou dans le module passe en plein ecran,
    // pas seulement dans le champ de saisie. Le bouton « reduire » est ignore ici,
    // sinon il se contredirait. Sur desktop, rien d'automatique (bouton plein ecran).
    if (this.mode === 'inline') {
      this.el.panel.addEventListener('click', function (e) {
        if (!MOBILE.matches || self.root.classList.contains('is-expanded')) return;
        if (e.target.closest && e.target.closest('[data-cc-close], [data-cc-maximize], [data-cc-reset]')) return;
        self.setExpanded(true);
      });
    }
    if (this.el.dismiss) this.el.dismiss.addEventListener('click', function (e) { e.stopPropagation(); self.dismiss(); });
    if (this.el.reset) this.el.reset.addEventListener('click', function () { self.reset(); });

    this.el.send.addEventListener('click', function () {
      if (self.busy) self.abort();
      else self.submit();
    });

    this.el.input.addEventListener('input', function () {
      self.autogrow();
      self.el.send.disabled = self.busy ? false : !self.el.input.value.trim();
    });
    this.el.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        if (!self.busy) self.submit();
      }
    });
    this.el.input.addEventListener('focus', function () {
      if (self.mode === 'inline' && MOBILE.matches) self.setExpanded(true);
      setTimeout(function () { self.scrollToEnd(true); }, 250);
    });

    if (this.el.leadFloat) this.el.leadFloat.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-lead-dismiss]')) {
        try { sessionStorage.setItem(LEAD_DISMISS_KEY, '1'); } catch (err) {}
        self.syncLeadFloat();
      } else if (e.target.closest('[data-cc-lead-open]')) {
        self.openLeadForm();
      }
    });

    this.el.chips.addEventListener('click', function (e) {
      if (e.target.closest('[data-cc-other]')) {
        self.el.input.focus();
        return;
      }
      var chip = e.target.closest('[data-cc-chip]');
      if (chip && !self.busy) self.submit(chip.dataset.ccChip);
    });
    this.el.log.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-cc-lead-form]');
      if (!form) return;
      e.preventDefault();
      self.submitLead(form);
    });

    this.el.log.addEventListener('click', function (e) {
      var add = e.target.closest('[data-cc-add]');
      if (add) {
        e.preventDefault();
        self.handleAdd(add);
        return;
      }
      var change = e.target.closest('[data-cc-grind-change]');
      if (change) {
        e.preventDefault();
        var box = change.closest('.coffee-chat-card__grind');
        var current = change.closest('.coffee-chat-card').dataset.grind;
        box.outerHTML = '<label class="coffee-chat-card__grind"><span>Mouture</span><select data-cc-grind>' + GRINDS.map(function (g) {
          return '<option value="' + escapeHtml(g) + '"' + (g === current ? ' selected' : '') + '>' + escapeHtml(g) + '</option>';
        }).join('') + '</select></label>';
        return;
      }
      var retry = e.target.closest('[data-cc-retry]');
      if (retry) {
        e.preventDefault();
        self.retry();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (self.maximized) {
        self.setMaximized(false);
        return;
      }
      if (self.isFullscreen()) {
        if (self.mode === 'bubble') self.setOpen(false);
        else self.setExpanded(false);
      }
    });

    // Clavier mobile : on cale le panneau sur le viewport visible pour que le
    // champ de saisie reste au-dessus du clavier (iOS ne redimensionne pas 100dvh).
    if (window.visualViewport) {
      var vv = window.visualViewport;
      var onViewport = function () { self.fitViewport(); };
      vv.addEventListener('resize', onViewport);
      vv.addEventListener('scroll', onViewport);
    }
    MOBILE.addEventListener('change', function () {
      if (MOBILE.matches && self.maximized) self.setMaximized(false);
      self.fitViewport();
      self.syncFullscreen();
    });
  };

  // Plein ecran desktop : le panneau couvre la fenetre, la page derriere ne defile plus.
  // En mode integre, le conteneur garde sa hauteur pour que la page ne saute pas.
  CoffeeChat.prototype.setMaximized = function (on) {
    var self = this;
    if (on && MOBILE.matches) return;
    if (on && this.mode === 'inline') this.root.style.minHeight = this.el.panel.offsetHeight + 'px';
    this.maximized = on;
    this.root.classList.toggle('is-maximized', on);
    this.lockPage(on);
    if (this.el.maximize) {
      this.el.maximize.setAttribute('aria-pressed', on ? 'true' : 'false');
      this.el.maximize.setAttribute('aria-label', on ? 'Quitter le plein écran' : 'Plein écran');
    }
    if (!on) this.root.style.minHeight = '';
    this.syncFullscreen();
    this.scrollToEnd(true);
    if (on) setTimeout(function () { self.el.input.focus(); }, 60);
  };

  CoffeeChat.prototype.isFullscreen = function () {
    if (!MOBILE.matches) return false;
    return this.mode === 'bubble' ? this.open : this.root.classList.contains('is-expanded');
  };

  // Plein ecran (mobile ouvert ou etendu, desktop maximise) : la barre d'en-tete disparait,
  // seuls restent deux boutons flottants, recommencer et fermer (classe lue par le CSS).
  CoffeeChat.prototype.syncFullscreen = function () {
    this.root.classList.toggle('is-fullscreen', this.maximized || this.isFullscreen());
  };

  CoffeeChat.prototype.fitViewport = function () {
    var panel = this.el.panel;
    if (!this.isFullscreen() || !window.visualViewport) {
      panel.style.height = '';
      panel.style.top = '';
      this.root.classList.remove('is-keyboard');
      return;
    }
    var vv = window.visualViewport;
    var keyboard = window.innerHeight - vv.height > 120;
    this.root.classList.toggle('is-keyboard', keyboard);
    if (keyboard) {
      panel.style.height = vv.height + 'px';
      panel.style.top = vv.offsetTop + 'px';
      window.scrollTo(0, 0);
      this.scrollToEnd(true);
    } else {
      panel.style.height = '';
      panel.style.top = '';
    }
  };

  CoffeeChat.prototype.lockPage = function (lock) {
    document.body.classList.toggle('coffee-chat-lock', lock);
  };

  CoffeeChat.prototype.setOpen = function (open) {
    var self = this;
    this.open = open;
    if (!open && this.maximized) this.setMaximized(false);
    this.root.classList.toggle('is-open', open);
    this.el.panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (this.el.launcher) this.el.launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (MOBILE.matches) this.lockPage(open);
    this.syncFullscreen();
    if (open) {
      this.ensureCatalog().catch(function () {});
      this.bootConversation();
      this.scrollToEnd(false);
      if (!MOBILE.matches) setTimeout(function () { self.el.input.focus(); }, 240);
    } else {
      this.fitViewport();
      if (this.el.launcher) this.el.launcher.focus();
    }
  };

  CoffeeChat.prototype.setExpanded = function (expanded) {
    this.root.classList.toggle('is-expanded', expanded);
    this.lockPage(expanded);
    this.syncFullscreen();
    if (!expanded) {
      this.el.input.blur();
      this.fitViewport();
      this.root.scrollIntoView({ block: 'center' });
    } else {
      this.scrollToEnd(true);
    }
  };

  CoffeeChat.prototype.autogrow = function () {
    var input = this.el.input;
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  };

  CoffeeChat.prototype.scrollToEnd = function (instant) {
    var log = this.el.log;
    if (instant) log.style.scrollBehavior = 'auto';
    log.scrollTop = log.scrollHeight;
    if (instant) log.style.scrollBehavior = '';
  };

  CoffeeChat.prototype.nearBottom = function () {
    var log = this.el.log;
    return log.scrollHeight - log.scrollTop - log.clientHeight < 80;
  };

  /* ── Rendu ────────────────────────────────────────────────────── */

  CoffeeChat.prototype.renderAll = function () {
    this.el.log.innerHTML = '';
    this.state.ui.forEach(function (m) { this.appendMessage(m); }, this);
    this.renderChips(this.state.chips);
    this.scrollToEnd(true);
  };

  CoffeeChat.prototype.appendMessage = function (m) {
    var wrap = document.createElement('div');
    wrap.className = 'coffee-chat__msg coffee-chat__msg--' + m.role;
    var bubble = document.createElement('div');
    bubble.className = 'coffee-chat__bubble';
    bubble.innerHTML = renderMarkdown(m.text || '');
    if (m.text) wrap.appendChild(bubble);
    if (m.cards && m.cards.length) wrap.appendChild(this.renderCards(m.cards));
    this.el.log.appendChild(wrap);
    return { wrap: wrap, bubble: bubble };
  };

  CoffeeChat.prototype.renderCards = function (cards) {
    var list = document.createElement('div');
    list.className = 'coffee-chat__cards';
    cards.forEach(function (c) {
      var p = c.product || this.byHandle[c.handle];
      if (!p) return;
      var brew = (p.brew || []).map(function (b) { return String(b); });
      var brewClass = brew.length >= 2 ? 'both' : (brew[0] || '').toLowerCase() === 'filtre' ? 'filtre' : 'espresso';
      var brewLabel = brew.length >= 2 ? brew[0] + ' & ' + brew[1] : brew[0] || '';
      var grind = grindFor(this.state.profile, p);
      var grindHtml = grind.choice
        ? '<label class="coffee-chat-card__grind"><span>Mouture</span><select data-cc-grind>' + GRINDS.map(function (g) {
            return '<option value="' + escapeHtml(g) + '"' + (g === grind.value ? ' selected' : '') + '>' + escapeHtml(g) + '</option>';
          }).join('') + '</select></label>'
        : '<div class="coffee-chat-card__grind coffee-chat-card__grind--fixed"><span>Mouture</span><strong>' + escapeHtml(grind.value) + '</strong> <button type="button" data-cc-grind-change>changer</button></div>';
      var card = document.createElement('article');
      card.className = 'coffee-chat-card';
      card.dataset.grind = grind.value;
      card.dataset.handle = p.handle || '';
      card.innerHTML =
        '<a class="coffee-chat-card__media" href="' + escapeHtml(p.url) + '">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy">' : '') +
          (brewLabel ? '<span class="coffee-chat-card__brew coffee-chat-card__brew--' + brewClass + '">' + escapeHtml(brewLabel) + '</span>' : '') +
        '</a>' +
        '<div class="coffee-chat-card__body">' +
          '<div class="coffee-chat-card__vendor">' + escapeHtml(p.vendor || '') + '</div>' +
          '<a class="coffee-chat-card__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title || '') + '</a>' +
          (p.notes && p.notes.length ? '<div class="coffee-chat-card__notes">' + p.notes.slice(0, 3).map(function (n) {
            return '<span class="coffee-chat-card__note">' + escapeHtml(String(n)) + '</span>';
          }).join('') + '</div>' : '') +
          (c.pourquoi ? '<div class="coffee-chat-card__why">' + escapeHtml(c.pourquoi) + '</div>' : '') +
          grindHtml +
          '<div class="coffee-chat-card__footer">' +
            '<div class="coffee-chat-card__price">' + escapeHtml(p.price || '') + (p.variant_title ? '<small>' + escapeHtml(p.variant_title) + '</small>' : '') + '</div>' +
            '<button type="button" class="coffee-chat-card__add" data-cc-add data-variant-id="' + escapeHtml(String(p.variant_id)) + '">Ajouter au panier</button>' +
          '</div>' +
        '</div>';
      list.appendChild(card);
    }, this);
    return list;
  };

  CoffeeChat.prototype.renderChips = function (options) {
    this.el.chips.innerHTML = '';
    /* Regle Manesse 27/09 : des qu'une premiere selection de cafes est affichee, un seul bouton
       jusqu'a l'envoi de l'email, et plus aucun bouton de reponse (meme si le modele en envoie). */
    var selected = this.lastCards().length > 0;
    if (selected) options = [];
    this.syncLeadFloat();
    (options || []).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'coffee-chat__chip';
      b.dataset.ccChip = o;
      b.textContent = o;
      this.el.chips.appendChild(b);
    }, this);
    /* Inciter a ecrire (choix Manesse 27/09) : un bouton « Autre... » qui met le curseur
       dans le champ, et une ligne discrete sous les boutons. */
    if (options && options.length) {
      var other = document.createElement('button');
      other.type = 'button';
      other.className = 'coffee-chat__chip coffee-chat__chip--other';
      other.setAttribute('data-cc-other', '');
      other.textContent = 'Autre…';
      this.el.chips.appendChild(other);
      var hint = document.createElement('span');
      hint.className = 'coffee-chat__chips-hint';
      hint.textContent = 'ou écrivez votre réponse ci-dessous';
      this.el.chips.appendChild(hint);
    }
  };

  /* ── Email : formulaire dans le chat, jamais dans la conversation ─
     Le modele propose de garder la selection (@@email) ; le widget affiche le bouton,
     puis un petit formulaire (email + case newsletter decochee). L'envoi va au serveur
     (POST /lead -> Klaviyo) avec les dernieres cartes et le profil de gout. Le modele
     ne voit jamais l'adresse. */

  CoffeeChat.prototype.lastCards = function () {
    for (var i = this.state.ui.length - 1; i >= 0; i--) {
      var m = this.state.ui[i];
      if (m.role === 'assistant' && m.cards && m.cards.length) return m.cards;
    }
    return [];
  };

  /* Pastille flottante « Recevoir un code promo -10 % » posee PAR-DESSUS le fil (28/09) :
     visible des qu'une selection est affichee, tant que l'email n'est pas envoye et que le
     formulaire n'est pas ouvert. La croix la range pour toute la session de navigation
     (sessionStorage, comme la croix de la bulle), meme apres « Recommencer » (regle Manesse 28/09). */
  CoffeeChat.prototype.leadDismissed = function () {
    try { return sessionStorage.getItem(LEAD_DISMISS_KEY) === '1'; } catch (e) { return false; }
  };

  CoffeeChat.prototype.syncLeadFloat = function () {
    var f = this.el.leadFloat;
    if (!f) return;
    var show = this.lastCards().length > 0 && !this.state.emailSent && !this.leadDismissed() &&
      !this.el.log.querySelector('[data-cc-lead-form]');
    f.hidden = !show;
    this.root.classList.toggle('has-lead', show);
  };

  CoffeeChat.prototype.openLeadForm = function () {
    if (this.el.log.querySelector('[data-cc-lead-form]')) return;
    var form = document.createElement('form');
    form.className = 'coffee-chat__lead';
    form.setAttribute('data-cc-lead-form', '');
    form.noValidate = true;
    form.innerHTML =
      '<p class="coffee-chat__lead-title">Je vous envoie votre sélection par email, avec votre code de -10 %, et je vous préviens quand un café dans vos goûts arrive.</p>' +
      '<div class="coffee-chat__lead-row">' +
        '<input type="email" name="email" class="coffee-chat__lead-input" placeholder="votre@email.fr" autocomplete="email" inputmode="email" required>' +
        '<button type="submit" class="coffee-chat__lead-send">Envoyer</button>' +
      '</div>' +
      '<label class="coffee-chat__lead-consent"><input type="checkbox" name="consent"> <span>Je veux aussi recevoir les nouveautés et offres Singular</span></label>' +
      '<p class="coffee-chat__lead-error" data-cc-lead-error hidden></p>';
    this.el.log.appendChild(form);
    this.syncLeadFloat();
    this.scrollToEnd(false);
    var input = form.querySelector('input[type="email"]');
    if (input && !MOBILE.matches) input.focus();
  };

  CoffeeChat.prototype.closeLeadForm = function () {
    var form = this.el.log.querySelector('[data-cc-lead-form]');
    if (form) form.remove();
    this.syncLeadFloat();
  };

  CoffeeChat.prototype.submitLead = function (form) {
    var self = this;
    var input = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[name="consent"]');
    var errorEl = form.querySelector('[data-cc-lead-error]');
    var btn = form.querySelector('.coffee-chat__lead-send');
    var email = (input.value || '').trim();
    var showErr = function (msg) { errorEl.textContent = msg; errorEl.hidden = false; };
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showErr('Vérifiez votre adresse email.');
      input.focus();
      return;
    }
    errorEl.hidden = true;
    btn.disabled = true;
    btn.textContent = '…';
    var cards = this.lastCards();
    var payload = {
      email: email,
      consent: !!(consent && consent.checked),
      conversation_id: this.state.id,
      intro: this.state.emailIntro || '',
      profile: this.state.profile || {},
      cafes: cards.map(function (c) {
        var p = c.product || self.byHandle[c.handle] || {};
        return { handle: c.handle, title: p.title, vendor: p.vendor, image: p.image, price: p.price, compare_at_price: p.compare_at_price || '', brew: p.brew, notes: p.notes, origin: p.origin, pourquoi: c.pourquoi };
      })
    };
    fetch(this.leadEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('http_' + r.status);
      return r.json();
    }).then(function (data) {
      if (data && data.error === 'unsubscribed') {
        // Adresse desinscrite des emails Singular : Klaviyo n'enverrait pas la selection.
        // On garde le formulaire ouvert et on demande de cocher la case (regle Manesse 27/09).
        btn.disabled = false;
        btn.textContent = 'Envoyer';
        showErr('Votre adresse est désinscrite de nos emails. Cochez la case ci-dessus pour recevoir la sélection.');
        if (consent) consent.focus();
        return;
      }
      self.state.emailSent = true;
      saveState(self.state);
      self.closeLeadForm();
      var note = { role: 'assistant', text: 'C\'est envoyé ! Votre sélection et votre code de -10 % arrivent dans votre boîte mail, et je vous préviens dès qu\'un café dans vos goûts entre en stock.', cards: [] };
      self.state.ui.push(note);
      saveState(self.state);
      self.appendMessage(note);
      self.renderChips(self.state.chips);
      self.scrollToEnd(false);
      self.syncOthers();
      if (window.dataLayer) window.dataLayer.push({ event: 'coffee_chat_lead', consent: payload.consent });
    }).catch(function (err) {
      if (self.debug) console.warn('[coffee-chat] lead', err);
      btn.disabled = false;
      btn.textContent = 'Envoyer';
      showErr('Ça n\'a pas marché, réessayez dans un instant.');
    });
  };

  CoffeeChat.prototype.showTyping = function () {
    var wrap = document.createElement('div');
    wrap.className = 'coffee-chat__msg coffee-chat__msg--assistant';
    wrap.innerHTML = '<div class="coffee-chat__bubble coffee-chat__typing" aria-label="Le conseiller écrit"><i></i><i></i><i></i></div>';
    this.el.log.appendChild(wrap);
    this.scrollToEnd(false);
    return wrap;
  };

  CoffeeChat.prototype.showError = function (message) {
    var div = document.createElement('div');
    div.className = 'coffee-chat__error';
    div.innerHTML = escapeHtml(message) + ' <button type="button" data-cc-retry>Réessayer</button>';
    this.el.log.appendChild(div);
    this.scrollToEnd(false);
  };

  /* ── Conversation ─────────────────────────────────────────────── */

  // Premier message : pre-ecrit, sans appel a l'IA, joue a la machine a ecrire.
  CoffeeChat.prototype.bootConversation = function () {
    if (this.state.ui.length || !this.welcome || this.booting) return;
    var self = this;
    this.booting = true;
    var msg = { role: 'assistant', text: '' };
    var nodes = this.appendMessage({ role: 'assistant', text: ' ' });
    nodes.bubble.classList.add('is-streaming');
    var tw = new Typewriter(function (text, done) {
      nodes.bubble.innerHTML = renderMarkdown(text);
      if (done) {
        nodes.bubble.classList.remove('is-streaming');
        msg.text = text;
        self.state.ui.push(msg);
        self.state.api.push({ role: 'assistant', content: text });
        self.state.chips = self.initialChips.slice();
        self.renderChips(self.state.chips);
        saveState(self.state);
        self.booting = false;
        self.syncOthers();
      }
      if (self.nearBottom()) self.scrollToEnd(false);
    });
    setTimeout(function () {
      tw.push(self.welcome);
      tw.finish();
    }, 350);
  };

  CoffeeChat.prototype.submit = function (forcedText) {
    var text = (forcedText != null ? forcedText : this.el.input.value).trim();
    if (!text || this.busy) return;
    // Garde contre les doubles tapes (deux clics en moins de 400 ms).
    var now = Date.now();
    if (now - (this.lastSubmit || 0) < 400) return;
    this.lastSubmit = now;
    if (forcedText == null) {
      this.el.input.value = '';
      this.autogrow();
    }
    this.el.send.disabled = false;
    // Formulaire email laisse ouvert : il se referme quand la conversation reprend (la pastille revient).
    this.closeLeadForm();

    this.state.chips = [];
    this.renderChips([]);
    this.state.api.push({ role: 'user', content: text });
    this.state.ui.push({ role: 'user', text: text });
    this.trimHistory();
    this.appendMessage({ role: 'user', text: text });
    this.scrollToEnd(false);
    saveState(this.state);
    this.request();
  };

  CoffeeChat.prototype.retry = function () {
    var errors = this.el.log.querySelectorAll('.coffee-chat__error');
    errors.forEach(function (e) { e.remove(); });
    if (this.state.api.length && this.state.api[this.state.api.length - 1].role === 'user') this.request();
  };

  CoffeeChat.prototype.abort = function () {
    if (this.controller) this.controller.abort();
  };

  CoffeeChat.prototype.trimHistory = function () {
    // On garde le premier message (accueil) et les derniers tours.
    while (this.state.api.length > MAX_TURNS) {
      this.state.api.splice(1, 2);
    }
  };

  CoffeeChat.prototype.setBusy = function (busy) {
    this.busy = busy;
    this.root.classList.toggle('is-busy', busy);
    this.el.send.disabled = busy ? false : !this.el.input.value.trim();
    this.el.send.setAttribute('aria-label', busy ? 'Arrêter la réponse' : 'Envoyer');
  };

  CoffeeChat.prototype.request = function () {
    var self = this;
    if (!this.endpoint) {
      this.showError("Le conseiller n'est pas encore branché.");
      return;
    }
    this.setBusy(true);
    var t0 = performance.now();
    var typing = this.showTyping();
    var nodes = null;
    var tw = null;
    var uiMsg = { role: 'assistant', text: '', cards: [] };
    var raw = '';
    var shown = '';
    var assistantContent = null;
    var chips = [];
    var timing = { ttft: null };

    var ensureBubble = function () {
      if (nodes) return;
      typing.remove();
      nodes = self.appendMessage({ role: 'assistant', text: ' ' });
      nodes.bubble.classList.add('is-streaming');
      tw = new Typewriter(function (text, done) {
        nodes.bubble.innerHTML = renderMarkdown(text);
        if (done) nodes.bubble.classList.remove('is-streaming');
        if (self.nearBottom()) self.scrollToEnd(false);
      });
    };

    var finalize = function () {
      var parsed = splitMarkers(raw, false);
      uiMsg.text = parsed.visible;
      uiMsg.cards = parsed.cards.filter(function (c) { return self.byHandle[c.handle]; })
        .map(function (c) { return { handle: c.handle, pourquoi: c.pourquoi, product: cardSnapshot(self.byHandle[c.handle]) }; });
      chips = parsed.chips;
      if (parsed.profile) {
        // Profil de gout ecrit par le modele avec la recommandation ; le dernier fait foi.
        self.state.profile = parsed.profile;
        if (window.dataLayer) window.dataLayer.push({ event: 'coffee_chat_reco', cafes: (parsed.profile.cafes || []).slice(0, 3) });
      }
      if (parsed.email) {
        self.state.emailOffered = true;
        if (parsed.email.intro) self.state.emailIntro = parsed.email.intro;
      }
      if (tw) {
        tw.full = parsed.visible;
        tw.flush();
      }
      typing.remove();
      if (!uiMsg.text && nodes) nodes.wrap.remove();
      if (uiMsg.cards.length) {
        var target = nodes ? nodes.wrap : self.appendMessage({ role: 'assistant', text: '' }).wrap;
        target.appendChild(self.renderCards(uiMsg.cards));
      }
      if (assistantContent && assistantContent.length) {
        self.state.api.push({ role: 'assistant', content: assistantContent });
        self.state.ui.push(uiMsg);
      } else if (uiMsg.text) {
        self.state.api.push({ role: 'assistant', content: uiMsg.text });
        self.state.ui.push(uiMsg);
      }
      self.state.chips = chips;
      self.renderChips(chips);
      saveState(self.state);
      self.scrollToEnd(false);
      self.setBusy(false);
      self.syncOthers();
      if (self.debug) console.debug('[coffee-chat] tour', timing);
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'coffee_chat_turn', ttft_ms: timing.ttft, total_ms: Math.round(performance.now() - t0) });
      }
    };

    this.controller = new AbortController();
    this.ensureCatalog().then(function () {
    fetch(self.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: self.state.api, catalog: self.catalogData, meta: { id: self.state.id, page: location.pathname, started: self.state.started } }),
      signal: self.controller.signal
    }).then(function (res) {
      if (!res.ok || !res.body) throw new Error('http_' + res.status);
      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var handle = function (ev) {
        if (ev.type === 'text') {
          raw += ev.text;
          var visible = splitMarkers(raw, true).visible;
          if (visible.length > shown.length) {
            if (timing.ttft == null) timing.ttft = Math.round(performance.now() - t0);
            ensureBubble();
            tw.push(visible.slice(shown.length));
            shown = visible;
          }
        } else if (ev.type === 'done') {
          assistantContent = ev.assistant;
          timing.server = ev.timing;
          timing.usage = ev.usage;
          if (tw) tw.finish();
        } else if (ev.type === 'error') {
          throw new Error(ev.code || 'error');
        }
      };
      var pump = function () {
        return reader.read().then(function (r) {
          if (r.done) return;
          buffer += decoder.decode(r.value, { stream: true });
          var parts = buffer.split('\n\n');
          buffer = parts.pop();
          parts.forEach(function (chunk) {
            var line = chunk.split('\n').filter(function (l) { return l.indexOf('data:') === 0; })[0];
            if (!line) return;
            handle(JSON.parse(line.slice(5)));
          });
          return pump();
        });
      };
      return pump();
    }).then(function () {
      if (!raw.trim() && !assistantContent) throw new Error('empty');
      finalize();
    }).catch(function (err) {
      typing.remove();
      if (tw) tw.flush();
      if (err && err.name === 'AbortError') {
        // Arret volontaire : on garde ce qui a ete ecrit.
        uiMsg.text = splitMarkers(raw, false).visible;
        if (uiMsg.text) {
          self.state.api.push({ role: 'assistant', content: uiMsg.text });
          self.state.ui.push(uiMsg);
          saveState(self.state);
        } else if (nodes) {
          nodes.wrap.remove();
        }
        self.setBusy(false);
        return;
      }
      if (nodes) nodes.wrap.remove();
      var msg = String(err && err.message || '');
      self.showError(
        msg === 'http_429' || msg === 'api_rate_limited' ? 'Beaucoup de monde en ce moment, réessayez dans un instant.' :
        msg === 'api_unavailable' ? 'Le conseiller est indisponible pour le moment, réessayez plus tard.' :
        'Petit souci de connexion.'
      );
      self.setBusy(false);
    });
    }).catch(function (err) {
      if (self.debug) console.warn('[coffee-chat] catalogue', err);
      typing.remove();
      self.setBusy(false);
      self.showError('Impossible de charger le catalogue du moment.');
    });
  };

  CoffeeChat.prototype.handleAdd = function (btn) {
    var self = this;
    var id = parseInt(btn.dataset.variantId, 10);
    if (!id || btn.disabled) return;
    var label = btn.textContent;
    var card = btn.closest('.coffee-chat-card');
    var select = card && card.querySelector('[data-cc-grind]');
    var grind = select ? select.value : (card && card.dataset.grind) || GRINDS[0];
    btn.disabled = true;
    btn.textContent = '…';
    addToCart(id, grind).then(function () {
      self.beacon('add_to_cart', { handle: card && card.dataset.handle || null, variant_id: id, grind: grind });
      btn.classList.add('is-added');
      btn.textContent = 'Ajouté ✓';
      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('is-added');
        btn.textContent = 'Ajouter encore';
      }, 2200);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = label;
    });
  };

  CoffeeChat.prototype.reset = function () {
    this.abort();
    this.state = emptyState();
    saveState(this.state);
    this.renderAll();
    this.syncOthers();
    this.bootConversation();
  };

  // Croix sur la bulle : on la range pour le reste de la visite (onglet), sans toucher a la conversation.
  CoffeeChat.prototype.dismiss = function () {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    this.root.hidden = true;
  };

  function isDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  }

  // Deux instances sur la meme page (bulle + integre) : on garde le meme fil.
  CoffeeChat.prototype.syncOthers = function () {
    instances.forEach(function (other) {
      if (other === this) return;
      other.state = loadState() || emptyState();
      other.renderAll();
    }, this);
  };

  /* ── Initialisation ───────────────────────────────────────────── */

  function init() {
    var roots = document.querySelectorAll('[data-coffee-chat]');
    // Bulle et chat integre cohabitent par defaut (meme fil de conversation). La section
    // integree peut demander a masquer la bulle sur sa page (case a cocher dans l'editeur).
    var hideBubble = Array.prototype.some.call(roots, function (r) {
      return r.dataset.mode === 'inline' && r.dataset.hideBubble === 'true';
    });
    var dismissed = isDismissed();
    roots.forEach(function (root) {
      if (root.dataset.mode !== 'inline') root.hidden = hideBubble || dismissed;
      if (root.dataset.ccReady || root.hidden) return;
      root.dataset.ccReady = '1';
      new CoffeeChat(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editeur de theme : re-init quand la section est (re)chargee.
  document.addEventListener('shopify:section:load', init);
})();
